// eslint-disable-next-line @typescript-eslint/no-unused-vars
import React from 'react'; // do not remove this import
import { createSvgIcon } from '@mui/material/utils';

import multipleStop from '@mui/icons-material/MultipleStopRounded';
import holdingPhone from '@mui/icons-material/PhoneIphoneRounded';
import time from '@mui/icons-material/AccessTimeRounded';
import schedule from '@mui/icons-material/CalendarTodayRounded';
import price from '@mui/icons-material/CheckCircleOutlineRounded';
import users from '@mui/icons-material/PeopleOutlineRounded';
import approved from '@mui/icons-material/ApprovalRounded';
import translate from '@mui/icons-material/GTranslateRounded';

const getInsertChart = (color: string) => {
  return createSvgIcon(
    <svg xmlns="http://www.w3.org/2000/svg" height="16" viewBox="0 -960 960 960" width="16" fill={color}><path d="M280-280h80v-280h-80v280Zm160 0h80v-400h-80v400Zm160 0h80v-160h-80v160ZM200-120q-33 0-56.5-23.5T120-200v-560q0-33 23.5-56.5T200-840h560q33 0 56.5 23.5T840-760v560q0 33-23.5 56.5T760-120H200Zm0-80h560v-560H200v560Zm0-560v560-560Z" /></svg>,
    'insertChart',
  );
};

const getTableChart = (color: string) => {
  return createSvgIcon(
    <svg xmlns="http://www.w3.org/2000/svg" height="16" viewBox="0 -960 960 960" width="16" fill={color}><path d="M760-120H200q-33 0-56.5-23.5T120-200v-560q0-33 23.5-56.5T200-840h560q33 0 56.5 23.5T840-760v560q0 33-23.5 56.5T760-120ZM200-640h560v-120H200v120Zm100 80H200v360h100v-360Zm360 0v360h100v-360H660Zm-80 0H380v360h200v-360Z" /></svg>,
    'tableChart',
  );
};

const getLinkIcon = (color: string) => {
  return createSvgIcon(
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M15.8333 15.8333H4.16667V4.16667H10V2.5H4.16667C3.24167 2.5 2.5 3.25 2.5 4.16667V15.8333C2.5 16.75 3.24167 17.5 4.16667 17.5H15.8333C16.75 17.5 17.5 16.75 17.5 15.8333V10H15.8333V15.8333ZM11.6667 2.5V4.16667H14.6583L6.46667 12.3583L7.64167 13.5333L15.8333 5.34167V8.33333H17.5V2.5H11.6667Z" fill={color} />
    </svg>,
    'linkIcon',
  );
};

const getRefreshIcon = (color: string) => {
  return createSvgIcon(
    <svg width="8" height="8" viewBox="0 0 16 8" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M6.82426 1.175C6.09881 0.45 5.10319 0 3.9975 0C1.78612 0 0 1.79 0 4C0 6.21 1.78612 8 3.9975 8C5.86366 8 7.41964 6.725 7.86492 5H6.82426C6.41401 6.165 5.30331 7 3.9975 7C2.34146 7 0.995622 5.655 0.995622 4C0.995622 2.345 2.34146 1 3.9975 1C4.82802 1 5.56848 1.345 6.10882 1.89L4.49781 3.5H8V0L6.82426 1.175Z" fill={color} />
    </svg>, 'refreshIcon',
  );
};

const getInfoIcon = (color: string) => {
  return createSvgIcon(
    <svg width="20" height="20" viewBox="6 -3 1 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M6 3.3325H7.33333V4.6655H6V3.3325ZM6 5.9985H7.33333V9.9975H6V5.9985ZM6.66667 0C2.98667 0 0 2.98592 0 6.665C0 10.3441 2.98667 13.33 6.66667 13.33C10.3467 13.33 13.3333 10.3441 13.3333 6.665C13.3333 2.98592 10.3467 0 6.66667 0ZM6.66667 11.997C3.72667 11.997 1.33333 9.60426 1.33333 6.665C1.33333 3.72573 3.72667 1.333 6.66667 1.333C9.60667 1.333 12 3.72573 12 6.665C12 9.60426 9.60667 11.997 6.66667 11.997Z" fill={color || "#284777"} />
    </svg>, 'infoIcon',
  );
};

const getReuseIcon = (color: string) => {
  return createSvgIcon(
    <svg width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M4.81144 5.19474L7.29281 1.0793C7.6862 0.423649 8.63436 0.423649 9.02775 1.0793L10.5206 3.56067L9.27992 5.63856L8.27124 7.27264L4.81144 5.19474ZM20.9 11.0653L19.2861 8.38219L15.796 10.3996L18.0252 14.1216H19.1651C19.9317 14.1216 20.6277 13.6879 20.9706 13.002C21.1118 12.7195 21.1824 12.4169 21.1824 12.1042C21.1824 11.7411 21.0816 11.3881 20.9 11.0653ZM15.1303 19.1651H16.6433C17.4099 19.1651 18.1059 18.7313 18.4489 18.0454L19.9115 15.1303H15.1303V13.1129L11.0956 17.1477L15.1303 21.1824V19.1651ZM9.07819 15.1303H4.74083L3.89353 16.5526C3.59093 17.0569 3.57075 17.6823 3.83301 18.2169C4.11544 18.7918 4.71057 19.1651 5.36622 19.1651H9.07819V15.1303ZM5.16448 12.4573L6.90951 13.5063L5.52761 7.96863L0 9.35053L1.71477 10.3794L1.30121 11.0754C0.948166 11.6705 0.917905 12.3968 1.2306 13.0121L2.87476 16.3004L5.16448 12.4573ZM16.1592 3.16728L14.8479 0.978427C14.4747 0.373214 13.819 0 13.1129 0H9.55227L12.6994 5.24517L10.9644 6.28412L16.5021 7.66602L17.884 2.12833L16.1592 3.16728Z" fill={color || '#44474E'} />
    </svg>, 'reuseIcon',
  );
};

const getBulbIcon = (color: string) => {
  return createSvgIcon(
    <svg width="15" height="21" viewBox="0 -2 13 21" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M4.03475 19.1651C4.03475 19.7198 4.48866 20.1737 5.04344 20.1737H9.07819C9.63296 20.1737 10.0869 19.7198 10.0869 19.1651V18.1564H4.03475V19.1651ZM7.06081 0C3.16728 0 0 3.16728 0 7.06081C0 9.46149 1.20034 11.5696 3.02606 12.8507V15.1303C3.02606 15.6851 3.47997 16.139 4.03475 16.139H10.0869C10.6417 16.139 11.0956 15.6851 11.0956 15.1303V12.8507C12.9213 11.5696 14.1216 9.46149 14.1216 7.06081C14.1216 3.16728 10.9543 0 7.06081 0ZM9.93557 11.1964L9.07819 11.8016V14.1216H5.04344V11.8016L4.18605 11.1964C2.82432 10.2483 2.01737 8.70497 2.01737 7.06081C2.01737 4.27683 4.27683 2.01737 7.06081 2.01737C9.84479 2.01737 12.1042 4.27683 12.1042 7.06081C12.1042 8.70497 11.2973 10.2483 9.93557 11.1964Z" fill={color || "#415F91"} />
    </svg>, 'bulbIcon',
  );
};

const insertChart = getInsertChart('black');
const insertChartWhite = getInsertChart('white');
const tableChart = getTableChart('black');
const tableChartWhite = getTableChart('white');
const link = getLinkIcon('#415F91');

export {
  insertChart,
  insertChartWhite,
  tableChart,
  tableChartWhite,
  approved,
  holdingPhone,
  multipleStop,
  price,
  users,
  time,
  translate,
  schedule,
  link,
  getRefreshIcon,
  getInfoIcon,
  getReuseIcon,
  getBulbIcon,
};
